/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaginationEntity,
  PaginationEntity$inboundSchema,
  PaginationEntity$Outbound,
  PaginationEntity$outboundSchema,
} from "./paginationentity.js";
import {
  SubscriptionEntity,
  SubscriptionEntity$inboundSchema,
  SubscriptionEntity$Outbound,
  SubscriptionEntity$outboundSchema,
} from "./subscriptionentity.js";

export type SubscriptionListEntity = {
  /**
   * List of subscription items
   */
  items: Array<SubscriptionEntity>;
  /**
   * Pagination details for the list
   */
  pagination: PaginationEntity;
};

/** @internal */
export const SubscriptionListEntity$inboundSchema: z.ZodType<
  SubscriptionListEntity,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(SubscriptionEntity$inboundSchema),
  pagination: PaginationEntity$inboundSchema,
});
/** @internal */
export type SubscriptionListEntity$Outbound = {
  items: Array<SubscriptionEntity$Outbound>;
  pagination: PaginationEntity$Outbound;
};

/** @internal */
export const SubscriptionListEntity$outboundSchema: z.ZodType<
  SubscriptionListEntity$Outbound,
  z.ZodTypeDef,
  SubscriptionListEntity
> = z.object({
  items: z.array(SubscriptionEntity$outboundSchema),
  pagination: PaginationEntity$outboundSchema,
});

export function subscriptionListEntityToJSON(
  subscriptionListEntity: SubscriptionListEntity,
): string {
  return JSON.stringify(
    SubscriptionListEntity$outboundSchema.parse(subscriptionListEntity),
  );
}
export function subscriptionListEntityFromJSON(
  jsonString: string,
): SafeParseResult<SubscriptionListEntity, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SubscriptionListEntity$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SubscriptionListEntity' from JSON`,
  );
}
